import styled from 'styled-components';

import { PopupMenuItem } from '@polyai/ui/components/molecules/PopupMenu';

export const ConvertToFunctionTrigger = styled(PopupMenuItem)`
  display: flex;
  justify-content: space-between;
`;
